/** @jsxRuntime classic */
/** @jsx jsxCustomEvent */
import jsxCustomEvent from '@micro-zoe/micro-app/polyfill/jsx-custom-event'
import { Skeleton } from 'antd'
import { useEffect, useState } from 'react'
import microApp from '@micro-zoe/micro-app'
import { useNavigate } from 'react-router-dom'
import request, {
  baseURL,
  requestHelper,
  getRefreshTokenApi,
  METHODS,
  sendRefreshToken,
  sviURL,
} from '@/api'
import { getTokenExpire, getUser, isTokenExpire, navigatePage, onLogout } from '@/common/utils'
import { useDebounceEffect } from 'ahooks'
import { abortRequest, controller } from '@/api'
import { defaultTheme } from '@/store'

function isSafari() {
  const ua = navigator.userAgent;
  return /Safari/i.test(ua) && /AppleWebKit/i.test(ua) &&
    !/(Chrome|Chromium|Edg|OPR)/i.test(ua) &&
    /iPad|iPhone|iPod/.test(ua);
}

export default function MicroApp(props: any) {
  const {
    appName,
    devUrl,
    prodUrl,
    disableSandbox,
    disableScopecss,
    baseroute,
    onDataChange,
    keepAlive = true,
  } = props

  const navigate = useNavigate()
  const microAppGlobalData = microApp.getGlobalData()

  const storeTheme = localStorage.getItem('ANTD_CONFIG_PROVIDER')
  const themeConfig = JSON.parse(storeTheme || '{}')

  const pushState = (path?: string, state?: any, search?: string) => {
    // console.log(path, state, search)
    let appNames = ''
    let newUrl = path
    let newSearch = search
    let index = path?.indexOf('?')
    let result = ''
    if (index > -1) {
      result = path?.substring(index)
      newUrl = path?.slice(0, index)
    }
    newSearch = search ? search : result
    let list = newUrl?.split('/').filter(Boolean)
    if (list.length > 0) {
      appNames = list[0]
      list.shift()
      newUrl = list.join('/')
    }
    // console.log(appNames, '/' + newUrl, newSearch);
    navigatePage(appNames, '/' + newUrl, navigate, state, newSearch)
  }

  const loginOut = () => {
    abortRequest(500).then(() => {
      navigate('/login')
      onLogout()
    })
  }

  const microData = {
    env: 'micro',
    globalNavigate: navigate,
    microApp: microApp,
    request,
    requestHelper,
    METHODS,
    baseURL,
    sviURL,
    refreshTokenApi: getRefreshTokenApi,
    sendRefreshToken: sendRefreshToken, // 只调用 刷新token接口 和 保存token
    isTokenExpire: isTokenExpire,
    getUser,
    pushState,
    loginOut,
  }

  microApp.setData(appName, {
    ...microData,
    themeConfig: microAppGlobalData?.themeConfig || storeTheme ? themeConfig : defaultTheme,
    userInfo: microAppGlobalData?.userInfo,
    locale: microAppGlobalData?.locale,
    buttonAuth: microAppGlobalData?.buttonAuth,
    openDownload: microAppGlobalData?.openDownload,
    onClickToMainAppPage: microAppGlobalData?.onClickToMainAppPage,
  })

  const url = { development: devUrl }[process.env.NODE_ENV as string] || prodUrl

  const [loading, setLoading] = useState(false)

  const handleEvent = (data: any) => {
    setLoading(data?.loading)
  }

  useEffect(() => {
    setLoading(true)
    microApp.addDataListener(appName, handleEvent, true)

    return () => {
      microApp.removeDataListener(appName, handleEvent)
    }
  }, [appName])

  //其他子应用内部跨子应用跳转 需要从基座下发路由实例给子应用

  const development = process.env.NODE_ENV === 'development'

  return (
    <div style={{ height: '100%' }}>
      {loading ? <Skeleton active /> : null}
      <micro-app
        name={appName}
        baseroute={baseroute}
        url={url}
        style={{ height: '100%' }}
        inline={development}
        keep-alive={!isSafari()}
        // disable-memory-router={true}
        disable-scopecss={false}
        disable-sandbox={false}
        baseURL={baseURL}
        onDataChange={onDataChange}
        // onMounted={() => {
        //   console.log('渲染完成');

        //   microApp.setData(appName, { pushState, loginOut })
        // }}
        data={microData}
      ></micro-app>
    </div>
  )
}
